export default class RouteOptions
{
  constructor(names, times, distance, topology, unevenness, difficulty, duration) 
  {
    this.names = names; // {} instead of array to support stringify
    this.times = times; // {} instead of array to support stringify
    this.distance = distance
    this.topology = topology
    this.unevenness = unevenness
    this.difficulty = difficulty
    this.duration = duration
  }    

  isValid()
  {
    var result = true;
    
    for (const [key, value] of Object.entries(this.names)) {
      if(!value)
      {
        result = false;
        break;
      }
    }
    for (const [key, value] of Object.entries(this.times)) {
      if(!value)
      {
        result = false;
        break;
      }
    }

    if(result) result = this.distance && this.topology && this.unevenness && this.difficulty && this.duration;

    return result;
  }
}